<template>
    <div>
<section class="page-title">
    <div class="center imagem more-padding">
        <h1 class="the-title"><span>Controle de</span> Dependentes Caarj</h1>
    </div>
    </section>           
    <v-container fluid>
    <v-flex xs12 sm12 lg12 style="text-align:end;">
    <v-btn
      style="border-radius: 6px;"              
      dark
      outline
      @click="sair"
      color="#009b9b"
      >Sair
    </v-btn> 
    </v-flex>
    <v-card-title>
      <v-flex xs12 sm12 lg12>
      <div>
      <span><h4 class="subtotal">Lista de titular e dependentes cadastrados</h4></span> 
      </div>
      </v-flex> 
      <v-flex xs12 sm12 lg6>
      <div>
        <br>
      <span><h4 class="subtotal" style="font-size:1.2rem;">Advogados: <span style="font-size:1.2rem; color:#009b9b">{{qtdTitular}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Dependentes / Agregados: <span style="font-size:1.2rem; color:#009b9b">{{qtddepagrd}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Dependentes: <span style="font-size:1.2rem; color:#009b9b">{{qtdDependentes}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Agregados: <span style="font-size:1.2rem; color:#009b9b">{{qtdAgregados}}</span></h4></span> 
      
      </div>
      </v-flex> 
      <v-flex xs12 sm12 lg6>
      <div>
        <br>
      <span><h4 class="subtotal" style="font-size:1.2rem;">Estagiários: <span style="font-size:1.2rem; color:#009b9b">{{qtdEstagiario}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Dependentes / Agregados: <span style="font-size:1.2rem; color:#009b9b">{{qtddepagrdEstag}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Dependentes: <span style="font-size:1.2rem; color:#009b9b">{{qtdDependentesEstag}}</span></h4></span> 
      <span><h4 class="subtotal" style="font-size:1.2rem;">Agregados: <span style="font-size:1.2rem; color:#009b9b">{{qtdAgregadosEstag}}</span></h4></span> 
      
      </div>
      <br>
      </v-flex> 
            
    </v-card-title>
<v-layout row wrap>   
<v-flex xs12 sm12 lg12>
    <v-layout row wrap>
    <v-flex xs7 sm7 lg7>                
    </v-flex> 
    <v-flex xs12 sm12 lg5>
    <v-text-field
        append-icon="search"
        label="Pesquisa"
        single-line
        hide-details
        v-model="search"
        style="margin-top: -5%;"        
      ></v-text-field>
      </v-flex> 
      </v-layout>
      <br>
  <v-data-table                       
    :headers="headersTitular" 
    :items="caarj"    
    :search="search"
    rows-per-page-text="Linhas por página"              
    :pagination.sync="pagination"
    class="elevation-2">     
    <v-progress-linear slot="progress" color="teal" indeterminate></v-progress-linear>         
      <template slot="items" slot-scope="props">      
        <td class="text-xs-left">{{ props.item.titular }}</td>
        <td class="text-xs-left">{{ props.item.contrato }}</td>
        <td class="text-xs-left">{{ props.item.sexo }}</td>
        <td class="text-xs-left">{{ props.item.cpf }}</td>
        <td class="text-xs-left">{{ props.item.nascimento }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.telefone }}</td>        
        <td class="text-xs-left">
        <v-tooltip bottom>
            <template slot="activator">
            <v-img  style="margin-left: 24%;" :src="require('../Content/images/green.png')" v-if="props.item.enviado == 'atualizado'" width="25"></v-img>
            <v-img style="margin-left: 24%;" :src="require('../Content/images/red.png')" v-else width="25"></v-img>
            </template>
            <span>{{props.item.enviado === 'atualizado' ? 'Dados Atualizados' : 'Atualização Pendente'}}</span>
          </v-tooltip>
        </td>
        <!-- <td class="text-xs-left">{{ props.item.dependentes != '' ? 'SIM' : 'NÃO'}}</td> -->
        <td class="justify-center layout px-0">                 
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn :disabled="props.item.dependentes == ''" icon class="mx-0" @click="consultaDep(props.item)">
                <v-icon color="teal">people_alt</v-icon>
              </v-btn>
            </template>
            <span>{{props.item.dependentes.length != 0 ? 'Com Dependente' : 'Sem Dependente'}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn :disabled="props.item.enviado == 'atualizado'" icon class="mx-0" @click="confirmaEnvio(props.item)">
                <v-icon color="#1565C0">check_circle</v-icon>
              </v-btn>
            </template>
            <span>Confirmar Cadastro no S4E</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template slot="activator">
              <v-btn icon class="mx-0" @click="resetSenha(props.item)">
                <v-icon color="#AFB42B">refresh</v-icon>
              </v-btn>
            </template>
            <span>Resetar Senha</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template slot="activator">
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir Cadastro</span>
          </v-tooltip>
          
        </td>
      </template>      
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        A pesquisa por "{{ search }}" não trouxe resultados.
      </v-alert>               
    </v-data-table>
    <v-layout row warp>
    <v-flex xs12 sm12 lg1>
    <v-tooltip bottom>
        <template slot="activator">
        <v-btn dark
            bottom
            left
            fab
            color="amber darken-3">
            <download-csv
            :data="dependenteToCSV"
            encoding="UTF-8"
            name="Dependentes_nao_cadastrados.csv"
            :separator-excel="true"
            >
            <v-icon large>cloud_download</v-icon>
            </download-csv>
        </v-btn>
    </template>
    <span>Dependentes / Agregados PENDENTES</span>
    </v-tooltip>
    </v-flex> 
    <v-flex xs12 sm12 lg1>
    <v-tooltip bottom>
        <template slot="activator">
        <v-btn dark
            bottom
            left
            fab
            color="deep-purple darken-2">
            <download-csv
            :data="dependenteToCSVFull"
            encoding="UTF-8"
            name="Todos_os_Dependentes.csv"
            :separator-excel="true"
            >
            <v-icon large>cloud_download</v-icon>
            </download-csv>
        </v-btn>
    </template>
    <span>Dependentes / Agregados</span>
    </v-tooltip>
    </v-flex>  
    <v-flex xs12 sm12 lg1>
    <v-tooltip bottom>
        <template slot="activator">
        <v-btn dark
            bottom
            left
            fab
            color="green darken-3">
            <download-csv
            :data="caarjCSV"
            encoding="UTF-8"
            name="Todos_os_Titulares.csv"
            :separator-excel="true"
            >
            <v-icon large>cloud_download</v-icon>
            </download-csv>
        </v-btn>
    </template>
    <span>Titulares</span>
    </v-tooltip>
    </v-flex>
    </v-layout> 
    <br>
    <span><h4 class="subtotal" style="font-size:1.2rem;">Cadastros Atualizados: <span style="font-size:1.2rem; color:#009b9b">{{qtdAtualizados}}</span></h4></span> 
    <span><h4 class="subtotal" style="font-size:1.2rem;">Cadastros Pendentes: <span style="font-size:1.2rem; color:#009b9b">{{qtdPendentes}}</span></h4></span> 
    <v-container fluid grid-list-md>
    <v-data-iterator
      v-if="caarjDep != ''"
      :items="caarjDep"
      rows-per-page-text="Linhas por página" 
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
      hide-actions
    >
      <template v-slot:header>
        <v-toolbar
          style="border-radius: 10px;"
          class="mb-2"
          color="#009B99"
          dark
          flat
        >
    <v-toolbar-title>Titular: {{titular}}</v-toolbar-title>
      </v-toolbar>
      </template>
      <template v-slot:item="props">
        <v-flex
          xs12
          sm6
          md4
          lg4
        >
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>

            <v-divider></v-divider>

            <v-list dense>
              
              <v-list-tile>
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;"> Parentesco:</b> {{ props.item.parentage}}</span></v-list-tile-content>
              </v-list-tile>              

              <v-list-tile>
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">Sexo:</b> {{ props.item.gender }}</span></v-list-tile-content>
              </v-list-tile> 

              <v-list-tile v-if="props.item.cpf">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">CPF:</b> {{ props.item.cpf }}</span></v-list-tile-content>
              </v-list-tile> 

              <v-list-tile v-if="props.item.dateOfBirth">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">Nascimento:</b> {{ formatDateBrz(props.item.dateOfBirth) }}</span></v-list-tile-content>
              </v-list-tile> 

              <v-list-tile v-if="props.item.maritalStatus">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">Estado Civil:</b> {{ props.item.maritalStatus }}</span></v-list-tile-content>
              </v-list-tile>  

              <v-list-tile v-if="props.item.motherName">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">Nome da Mãe:</b> {{ props.item.motherName }}</span></v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="props.item.susNumber">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">CNS:</b> {{ props.item.susNumber }}</span></v-list-tile-content>
              </v-list-tile> 

              <v-list-tile v-if="props.item.valuePlan">
                <v-list-tile-content class="dependentes" ><span> <b style="color:#009b9b;font-weight: bold;">Valor do Plano R$:</b> {{ props.item.valuePlan }}</span></v-list-tile-content>
              </v-list-tile>         
        
            </v-list>
          </v-card>
        </v-flex>
      </template>      
    </v-data-iterator>
    </v-container> 
    </v-flex>
    </v-layout> 
      <v-dialog v-model="dialogLoading" max-width="600px" max-height="400px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total" style="font-size:1.7rem;">Envio de dependentes para o S4E</span>              
              </v-card-title>
              <v-container
                    fluid
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" v-for="mensagem in mensagemS4E" :key="`${mensagem}`">- {{mensagem}}</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="close()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
    </v-container>
    <loading :active.sync="isLoading" 
        :can-cancel="true" 
        color="#446fb5"
        :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    </div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { mapState } from 'vuex'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components: {Snackbar, Loading},
     data(){
        return{
            fullPage: true,  
            isLoading: false,
            mensagemS4E: [],
            statusCad: '',
            dialogLoading: false,           
            pagination: {'sortBy': 'name', 'rowsPerPage': 10},
            search: '',
            headersTitular: [
            {
                text: 'Titular',
                align: 'left',
                value: 'titular'
            },
            { text: 'Contrato',align: 'left', value: 'contrato' },
            { text: 'Sexo',align: 'left', value: 'sexo' },
            { text: 'CPF',align: 'left', value: 'cpf' },
            { text: 'Nascimento',align: 'left', value: 'nascimento' },            
            { text: 'Email',align: 'left', value: 'email', width: '10px' },            
            { text: 'Telefone',align: 'left', value: 'telefone' },  
            { text: 'Situação',align: 'left', value: 'enviado' },          
            /* { text: 'Dep.',align: 'left', value: 'dependentes' }, */
            { text: 'Ações', align: 'center', value: 'name', sortable: false }
                ],
            caarj: [],
            titular: '',
            caarjDep: [],
            titularNaoAtualizado: [],
            dependenteToCSV: [],
            caarjCSV: [],
            dependenteToCSVFull: [],
            dependenteTratamento: [],
            dependenteTratamentoFull: [],
            qtdDependentes: 0,
            qtdDependentesEstag: 0,
            qtdTitular: 0,
            qtdEstagiario: 0,
            qtdAgregados: 0,
            qtddepagrd: 0,
            qtdPendentes: 0,
            qtdAgregadosEstag: 0,
            qtddepagrdEstag: 0,
            qtdPendentesEstag: 0,
            qtdAtualizados: 0,
            qtdErroEnvio: 0,
            header: {
                ID: 'ID'                
            },
            dependentes:{
              codigoParceiro: 61295,
              codigoResponsavelFinanceiro: '',
                  dependente: {
                  tipo:  '',
                  nome: '',
                  dataNascimento: '',
                  cpf: '',
                  sexo: '',
                  plano: '',
                  planoValor: '',
                  nomeMae: '',
                  numeroProposta: '',
                  telefoneFixo: '',
                  celular:'',
                  celular2:'',
                  email:''
              }
            },
          defaultDependents:{
              codigoParceiro: 61295,
              codigoResponsavelFinanceiro: '',
                  dependente: {
                  tipo:  '',
                  nome: '',
                  dataNascimento: '',
                  cpf: '',
                  sexo: '',
                  plano: '',
                  planoValor: '',
                  nomeMae: '',
                  numeroProposta: '',
                  telefoneFixo: '',
                  celular:'',
                  celular2:'',
                  email:''
              }
            }

            }
    },
    computed: mapState({
        userloggedin: state => state.userloggedin,
    }),
    mounted : function(){
        this.carregaDados()

    },
    methods: {

      async carregaContadores(){

      },

        async carregaDados(){ 
        this.isLoading = true                
         await axios
          .get(`${baseApiUrl}caarjs`)
          .then(res => {
           if(res.data != ''){
             this.caarj = res.data
             this.caarjDep = ''             
           }           
          })
          //this.qtdTitular = this.caarj.length
          this.caarj.forEach( (item) => {
            if(item.enviado == 'atualizado')
            this.qtdAtualizados = this.qtdAtualizados + 1
            else
            if(item.enviado == '' || item.enviado == 'pendente' && item.dependentes != '')
            this.qtdPendentes = this.qtdPendentes + 1

            if(item.contratoEmpresa == "502229")
            this.qtdEstagiario = this.qtdEstagiario + 1

            if(item.contratoEmpresa == undefined || item.contratoEmpresa == '502192')
            this.qtdTitular = this.qtdTitular + 1

            if ((item.dependentes.length != 0) && (item.contratoEmpresa == undefined || item.contratoEmpresa == '502192')){
              this.qtddepagrd = this.qtddepagrd + item.dependentes.length
              item.dependentes.forEach( (item2) => {
                if(item2.parentage == 'PAI/MÃE' || item2.parentage == 'AGREGADO')
                this.qtdAgregados = this.qtdAgregados + 1
                else
                this.qtdDependentes = this.qtdDependentes + 1
              })
            }

            if (item.dependentes.length != 0 && item.contratoEmpresa == "502229"){
              this.qtddepagrdEstag = this.qtddepagrdEstag + item.dependentes.length
              item.dependentes.forEach( (item2) => {
                if(item2.parentage == 'PAI/MÃE' || item2.parentage == 'AGREGADO')
                this.qtdAgregadosEstag = this.qtdAgregadosEstag + 1
                else
                this.qtdDependentesEstag = this.qtdDependentesEstag + 1
              })
              
            }
            }) 

            this.caarj.forEach( (titular) => {
            this.contratoTitular = titular.contrato                
            if (titular.dependentes.length != 0){
              titular.dependentes.forEach( (depend) => {
                
                if(depend.gender == 1)
                depend.gender = 'MASCULINO'
                else
                depend.gender = 'FEMININO'
                depend.valuePlan.replace(/[\\"]/g, '')
                depend.firstName = depend.firstName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.parentage = depend.parentage.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.maritalStatus = depend.maritalStatus.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.motherName = depend.motherName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                var contratoTit = {"contrato" : titular.contrato, "data" : titular.data, "contratoEmpresa" : titular.contratoEmpresa == undefined ? '502192' : titular.contratoEmpresa}
                this.dependenteTratamentoFull.push(this.jsonConcat(depend,contratoTit))
                            
              })
            }
            })
            
            this.caarj.forEach( (titular) => {
            if(titular.enviado != 'atualizado')
            {
            this.contratoTitular = titular.contrato                
            if (titular.dependentes.length != 0){
              titular.dependentes.forEach( (depend) => {
                
               /*  if(depend.gender == 1)
                depend.gender = 'MASCULINO'
                else
                depend.gender = 'FEMININO' */
                depend.valuePlan.replace(/[\\"]/g, '')
                depend.firstName = depend.firstName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.parentage = depend.parentage.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.maritalStatus = depend.maritalStatus.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                depend.motherName = depend.motherName.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                var contratoTit = {"contrato" : titular.contrato, "data" : titular.data, "contratoEmpresa" : titular.contratoEmpresa == undefined ? '502192' : titular.contratoEmpresa}
                this.dependenteTratamento.push(this.jsonConcat(depend,contratoTit))
                            
              })
            }
            }
            })

            for (var key in this.dependenteTratamentoFull) {
                    if (this.dependenteTratamentoFull.hasOwnProperty(key)) {
                        this.dependenteToCSVFull.push({
                        'CONTRATO_EMPRESA': this.dependenteTratamentoFull[key].contratoEmpresa,
                        'CONTRATO': this.dependenteTratamentoFull[key].contrato,
                        'PARENTESCO': this.dependenteTratamentoFull[key].parentage,
                        'NOME': this.dependenteTratamentoFull[key].firstName,
                        'SEXO': this.dependenteTratamentoFull[key].gender,
                        'CPF': this.dependenteTratamentoFull[key].cpf,
                        'NASCIMENTO': this.dependenteTratamentoFull[key].dateOfBirth,
                        'ESTADO CIVIL': this.dependenteTratamentoFull[key].maritalStatus,
                        'NOME DA MAE': this.dependenteTratamentoFull[key].motherName,
                        'VALOR': this.dependenteTratamentoFull[key].valuePlan,
                        'DATA_CADASTRO': this.dependenteTratamentoFull[key].data,
                            });
                        }
                }

            for (var key2 in this.dependenteTratamento) {
                    if (this.dependenteTratamento.hasOwnProperty(key2)) {
                        this.dependenteToCSV.push({   
                        'CONTRATO_EMPRESA': this.dependenteTratamento[key2].contratoEmpresa,                     
                        'CONTRATO': this.dependenteTratamento[key2].contrato,
                        'PARENTESCO': this.dependenteTratamento[key2].parentage,
                        'NOME': this.dependenteTratamento[key2].firstName,
                        'SEXO': this.dependenteTratamento[key2].gender,
                        'CPF': this.dependenteTratamento[key2].cpf,
                        'NASCIMENTO': this.dependenteTratamento[key2].dateOfBirth,
                        'ESTADO CIVIL': this.dependenteTratamento[key2].maritalStatus,
                        'NOME DA MAE': this.dependenteTratamento[key2].motherName,
                        'VALOR': this.dependenteTratamento[key2].valuePlan,
                        'DATA_CADASTRO': this.dependenteTratamentoFull[key2].data,
                            });
                        }
                }
            
            for (var key3 in this.caarj) {
                    if (this.caarj.hasOwnProperty(key3)) {
                        this.caarjCSV.push({
                        'CONTRATO_EMPRESA': this.caarj[key3].contratoEmpresa == undefined ? '502192' : this.caarj[key3].contratoEmpresa,
                        'CONTRATO': this.caarj[key3].contrato,
                        'NOME': this.caarj[key3].titular,
                        'CPF': this.caarj[key3].cpf,
                        'EMAIL': this.caarj[key3].email,                        
                        'TELEFONE': this.caarj[key3].telefone,
                        'CEP': this.caarj[key3].cep,
                        'RUA': this.caarj[key3].rua,
                        'NUMERO': this.caarj[key3].numero,
                        'COMPLEMENTO': this.caarj[key3].complemento,
                        'BAIRRO': this.caarj[key3].bairro,
                        'CIDADE': this.caarj[key3].cidade,
                        'ESTADO': this.caarj[key3].estado,                        
                        'DATA_CADASTRO' : this.caarj[key3].data,
                        'SITUACAO': this.caarj[key3].enviado === 'pendente' ? 'PENDENTE' : 'ATUALIZADO'
                            });
                        }
                }

        this.isLoading = false 
      },
      jsonConcat(o1, o2) {
        for (var key in o2) {
        o1[key] = o2[key];
        }
        return o1;
        },
      gerarLink() {
          if(this.idPlano == '')
          {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe o plano para gerar o link!","ATENÇÃO");
          }
          else
          if(this.nomeVendedor == '' || this.cpfVendedor == '')
          this.link = 'https://ecommerce.primavida.com.br/contratopf?plano='+this.idPlano
          else
          this.link = 'https://ecommerce.primavida.com.br/contratopf?plano='+this.idPlano+'&vendedor='+this.cpfVendedor
      },
      consultaDep(item){
          this.titular = item.titular
          //this.caarj[0].dependentes = Object.assign({})
          this.caarjDep = item.dependentes
      },
      formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async deleteItem(item){
          var r = confirm('Deseja realmente excluir o cadastro do Titular: '+item.titular+'?')
          if(r ==true) {
          await axios.delete(`${baseApiUrl}caarjs/${item.id}`)
            .then(() => {    
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1","Operação realizada, o usuário foi excluído!","INFORMAÇÃO");
                this.carregaDados()                              
            })
          }
      },
      async resetSenha(item){

          var r = confirm('Deseja realmente resetar a senha para o Titular: '+item.titular+'?')
          if(r ==true) {
          await axios.patch(`${baseApiUrl}caarjs/${item.id}`, { "senha" : ""})
            .then(() => {  
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1","Operação realizada, a senha foi resetada!","INFORMAÇÃO");   
                this.carregaDados()              
            })
          }

      },
      /* async confirmaEnvio(item){
          var r = confirm('Confirma a atualização de todos os dados do Titular: '+item.titular+' no S4E?')
          if(r ==true) {
          await axios.patch(`${baseApiUrl}caarjs/${item.id}`, { "enviado" : "atualizado"})
            .then(() => {  
                var vm = this
                vm.$refs.chamaSnackbar.snack("#0288D1","Operação realizada, registrada a informação de atualização dos dados no S4E!","INFORMAÇÃO");   
                this.carregaDados()              
            })
          }
      }, */
      async confirmaEnvio(item){ 
         this.mensagemS4E = []  
         this.qtdErroEnvio = 0    
          var r = confirm('Confirma a importação de todos os dependentes do Titular: '+item.titular+' no S4E?')
          if(r ==true) {
           this.isLoading = true
           
           //PEGA O CODIDO DO PLANO DO TITULAR
         await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": item.cpf,"empresa": 0,"incluirDependentes":1}).then(res => {         
                if(res.data.Data.length > 0){
                   res.data.Data.forEach( (titular) => {
                   this.dependentes.dependente.plano = titular.Dependente[0].IdPlano             
              })
              }          
              })

          for(var i2=0; i2<item.dependentes.length; i2++) {
             /* this.insereDependenteS4E(item.dependentes[i2]) */             
              this.dependentes.dependente.tipo = item.dependentes[i2].parentage
              this.dependentes.dependente.nome = item.dependentes[i2].firstName
              this.dependentes.dependente.dataNascimento = item.dependentes[i2].dateOfBirth
              this.dependentes.dependente.cpf = item.dependentes[i2].cpf.replace(/[^\d]+/g,'')

              if(item.dependentes[i2].gender == 'MASCULINO')
              this.dependentes.dependente.sexo = 1
              else
              this.dependentes.dependente.sexo = 0
              this.dependentes.dependente.planoValor = item.dependentes[i2].valuePlan
              this.dependentes.dependente.nomeMae = item.dependentes[i2].motherName
              this.dependentes.dependente.numeroProposta = Math.floor(10000 + Math.random() * 10000).toString()
              this.dependentes.codigoResponsavelFinanceiro = parseInt(item.contrato)
/*               item.dependentes = this.dependentes           
              objeto = Object.assign({}, item) */
              this.insereDependenteS4E(this.dependentes)
            } 
        
          setTimeout(() => {
          if(this.qtdErroEnvio > 0)
          this.statusCad = 'pendente'
          else
          this.statusCad = 'atualizado'
           axios.patch(`${baseApiUrl}caarjs/${item.id}`, { "enviado" : this.statusCad})
            .then(() => {  
                this.isLoading = false 
                this.dialogLoading = true
                this.carregaDados()              
            }) 
          }, 6000);

          }
      },
      async insereDependenteS4E(dados)
        {
            await axios.post(`${baseApiUrl}APIS4s/NovoDependente`, dados).then(res => { 
              if(res.data != "") 
                this.salvaLogDependente(res.data.mensagem, dados)

                if(res.data.codigo == 1) {
                   this.mensagemS4E.push(dados.dependente.nome + ' inserido(a) com sucesso!')                                                           
                }                                     
                else
                 if(res.data.mensagem != null && res.data.mensagem.includes("Titular nao")) {
                   this.mensagemS4E.push('Não foi possível inserir ' + dados.dependente.nome + ', titular não pode inserir dependentes no contrato, contate a Primavida!')                     
                   this.qtdErroEnvio = this.qtdErroEnvio + 1                 
                }
                else 
                if(res.data.codigo == 3 && res.data.mensagem.includes("cadastrado e ativo no contrato")) {
                   //this.mensagemS4E.push(dados.dependente.nome + ' já possui cadastro ativo no contrato ' + 'com o CPF : ' + dados.dependente.cpf )                                       
                   setTimeout(() => {
                      this.consultaAssociado(dados)
                   }, 1000);
                   //this.qtdErroEnvio = this.qtdErroEnvio + 1 
                }
                else 
                if(res.data.codigo == 3 && res.data.mensagem.includes("Violation of PRIMARY KEY constraint")) {
                   this.mensagemS4E.push("Erro ao Inserir o dependende: " + dados.dependente.nome + " tente novamente")                                       
                   this.qtdErroEnvio = this.qtdErroEnvio + 1 
                }
                              
                }).catch(() => {
                    this.mensagemS4E.push('Erro ao inserir Dependentes / Agregados no contrato, contate à administração do sistema!')                     
                    this.qtdErroEnvio = this.qtdErroEnvio + 1                 
                  })            
        },
         async salvaLogDependente(mensagem, dados){          
           await axios.post(`${baseApiUrl}logDependentes`, {"mensagem" : mensagem, "data" : new Date().toLocaleString(), "titular" : dados.codigoResponsavelFinanceiro})
           this.dependents = Object.assign({}, this.defaultDependents)
        },

        async consultaAssociado(dados){
         await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": dados.dependente.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
                if(res.data.Data.length > 0){
                   res.data.Data.forEach( (titular) => {
                if(titular.Dependente[0].Situacao == "1")
                  {
                    this.qtdErroEnvio = this.qtdErroEnvio + 1
                    this.mensagemS4E.push(dados.dependente.nome + ' já possui cadastro ativo como Titular ' + 'com o CPF : ' + dados.dependente.cpf )
                  } 
                  else{
                  this.mensagemS4E.push(dados.dependente.nome + ' já possui cadastro ativo no contrato ' + 'com o CPF : ' + dados.dependente.cpf )                
                  }             
              })
              }
              else{
                  this.mensagemS4E.push(dados.dependente.nome + ' já possui cadastro ativo no contrato ' + 'com o CPF : ' + dados.dependente.cpf )                
                }             
              })
              .catch(() => {
                  this.qtdErroEnvio = this.qtdErroEnvio + 1 
                  this.mensagemS4E.push("Erro ao Inserir o depentende: " + dados.dependente.nome + " tente novamente")                
                })                
      },
      close(){
        this.dialogLoading = false
      },
      sair()
      {
        localStorage.clear('userPermission')
        window.location.reload()
      }
    }

}
</script>

<style>
    .link{
        font-size: 1.3rem;
        color: #009b9b;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagem{
        background: url('../Content/images/parceria2.png') center right no-repeat;
        background-size: contain;
    }
    .dependentes {
    color: #797a7a;
    font-size: 1rem;
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
}
</style>
